import { PaginationRequest, PaginationResult } from '@shared/pagination';

import { Nadac } from '@/features/nadacs';
import { artiaProtectedApi } from '@/lib/api-client';
import { buildQueryString } from '@/utils/filtering-functions';

export type NadacSearchRequest = {
  ndc?: string;
  description?: string;
} & PaginationRequest;

export const searchNadacs = async (request: NadacSearchRequest): Promise<PaginationResult<Nadac>> => {
  return await artiaProtectedApi.get(`medicaid/nadacs${buildQueryString(request)}`);
};
